import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import QRCode from 'qrcode';

import { DemoozButtonComponent } from '@demooz/components';
import { DataService } from '@app/services';

@Component({
    selector: 'app-sponsor',
    templateUrl: './sponsor.component.html',
    styleUrls: ['./sponsor.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => DemoozButtonComponent)
    ]
})
export class SponsorComponent  implements OnInit {
       
    QRCodeURL: string;
    dataQRCode: string|null = null; 
    isShareSupported: boolean = false; 
       
    constructor(             
        public dataService: DataService
    ) { }

    async ngOnInit() {
        this.QRCodeURL = this.dataService.operation.sponsorContent?.url 
            + (this.dataService.operation.sponsorContent?.mustAddEmail && this.dataService.ambassador.value?.email ? this.dataService.ambassador.value?.email : '');
        if(this.QRCodeURL){
            this.dataQRCode = await QRCode.toDataURL(this.QRCodeURL);
        }
        this.isShareSupported = (typeof navigator.share === 'function');
    }
    
    async shareLinkSponsor(){
        let shareData = {
            title: ' ',
            text: '',
            url: this.QRCodeURL
        };
        await navigator.share(shareData);
    }
}
